module.exports = __webpack_public_path__ + "static/media/table_1.ad2b8390.png";